import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled(Form)`
  p.Mui-error {
    margin-top: 0;
  }
`;
